import { createEnv } from "@t3-oss/env-core";
import { z } from "zod";

const ENV_LINE_BREAK_REGEX = /\r?\n/;

const sanitizeEnvValue = (value: unknown): unknown => {
  if (typeof value !== "string") {
    return value;
  }

  return value.split(ENV_LINE_BREAK_REGEX, 1)[0]?.trim();
};

const runtimeEnv = Object.fromEntries(
  Object.entries(import.meta.env).map(([key, value]) => [
    key,
    sanitizeEnvValue(value),
  ])
);
const publicConvexUrl =
  (typeof runtimeEnv.PUBLIC_CONVEX_URL === "string"
    ? runtimeEnv.PUBLIC_CONVEX_URL
    : undefined) ??
  (typeof runtimeEnv.CONVEX_URL === "string"
    ? runtimeEnv.CONVEX_URL
    : undefined);

export const env = createEnv({
  /**
   * Specify your client-side environment variables schema here.
   * For Vite, all client vars use the PUBLIC_ prefix
   */
  clientPrefix: "PUBLIC_",

  client: {
    PUBLIC_CONVEX_URL: z.string().url(),
    PUBLIC_VORTEX_AUTH_URL: z.string().url(),
    PUBLIC_STRIPE_PUBLISHABLE_KEY: z.string().startsWith("pk_"),
    PUBLIC_POSTHOG_KEY: z.string().optional(),
    PUBLIC_POSTHOG_HOST: z.string().url().optional(),
    PUBLIC_AXIOM_TOKEN: z.string().optional(),
    PUBLIC_AXIOM_DATASET: z.string().optional(),
    PUBLIC_AXIOM_ORG_ID: z.string().optional(),
    PUBLIC_ENVIRONMENT: z
      .enum(["development", "staging", "production"])
      .optional(),
  },

  /**
   * Use import.meta.env for Vite instead of process.env
   */
  runtimeEnv: {
    ...runtimeEnv,
    PUBLIC_CONVEX_URL: publicConvexUrl,
  },

  /**
   * Makes it so that empty strings are treated as undefined.
   * `SOME_VAR: z.string()` and `SOME_VAR=''` will throw an error.
   */
  emptyStringAsUndefined: true,
});
